module.exports = __webpack_public_path__ + "static/media/flame3.46c03a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/flame3.png
// module id = 896
// module chunks = 0